export default __webpack_public_path__ + "/dist/images/growth-img.a33bd5e866c06ad82bf800f5bf6f8f03.png";